import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Chart, ChartConfiguration, ChartItem, registerables } from 'chart.js';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import QRCode from 'qrcode';
import * as tf from '@tensorflow/tfjs';
import * as faceapi from 'face-api.js';
import QrScanner from 'qr-scanner';
import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public standalone = JSON.parse(new URLSearchParams(window.location.search).get("standalone") || 'false');
  public shareObject: any = {};
  public env = environment;
  public messageSubject = new BehaviorSubject('');
  public Message = this.messageSubject.asObservable();
  public toastSubject = new BehaviorSubject({});
  public Toast = this.toastSubject.asObservable();
  public alertSubject = new BehaviorSubject(null);
  public Alert = this.alertSubject.asObservable();
  public confirmSubject = new BehaviorSubject(null);
  public Confirm = this.confirmSubject.asObservable();
  public onConfirm = new BehaviorSubject<boolean>(false);
  private manifestLink: HTMLLinkElement;
  modals: any = {};
  constructor(
    private http: HttpClient,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
  ) {
    Chart.register(...registerables);
    this.manifestLink = document.querySelector('link[rel="manifest"]')!;
    let subHost: any = window.location.hostname?.split('.')?.shift();
    if (!['localhost', 'www', 'aqbakery', 'aqb', '192', '127'].includes(subHost)) {
      this.standalone = true;
      this.setManifest(`/manifest-${subHost}.webmanifest`);
    }
    // this.loadModels();
    this.translateKeyword();
  }
  static getUser() {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }
  isAdmin() {
    let user = SharedService.getUser();
    if (user && user.roles && (user.roles.includes('admin.index') || user.roles.includes('admin.super'))) {
      return true;
    }
    return false;
  }
  setManifest(manifestUrl: string): void {
    this.manifestLink.setAttribute('href', manifestUrl);
  }
  async pwaInstall(manifestUrl: string = '') {
    let oldManifestUrl = this.manifestLink.getAttribute('href');
    if (oldManifestUrl && oldManifestUrl != manifestUrl) {
      this.manifestLink.setAttribute('href', manifestUrl);
    }
    let manifestInfo = await fetch(manifestUrl).then((res) => res.json());
    let deferredPrompt: any;
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      deferredPrompt = e;
      this.toast({
        title: this.translate.instant('install_app'),
        message: this.translate.instant('install_app_message'),
        type: 'info',
      });
    });
    this.toastSubject.subscribe((data: any) => {
      if (data && data.type == 'info' && deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult: any) => {
          if (choiceResult.outcome === 'accepted') {
            this.toast({
              title: this.translate.instant('app_installed'),
              message: `${manifestInfo.name} ${this.translate.instant('app_installed_message')}`,
              type: 'success',
            });
            if (oldManifestUrl && oldManifestUrl != manifestUrl) {
              this.manifestLink.setAttribute('href', manifestUrl);
            }
            location.href = manifestInfo.start_url;
          } else {
            this.toast({
              title: this.translate.instant('install_app_failed'),
              message: this.translate.instant('install_app_failed_message'),
              type: 'warning',
            });
          }
          deferredPrompt = null;
        });
      }
    });

  }
  confirm(e: any) {
    this.confirmSubject.next(e);
    return new Promise((resolve) => {
      this.onConfirm = new BehaviorSubject<boolean>(false);
      this.onConfirm.subscribe((data: any) => {
        if (data) {
          resolve(data);
        }
      });
    });
  }
  alert(e: any) {
    this.alertSubject.next(e);
  }
  toast(e: any) {
    if (e && e.type && e.type == 'error') {
      e.type = 'danger';
    }
    this.toastSubject.next(e);
  }
  login(email: string, password: string, staySignedIn: boolean): Observable<any> {
    let request = this.http.post(`${this.env.apiUrl}/auth/login`, { email, password, staySignedIn });
    return request.pipe(
      // Nếu lỗi login
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toast({
            title: this.translate.instant('unauthorized'),
            message: this.translate.instant('unauthorized_message'),
            type: 'danger',
          });
          localStorage.removeItem('user');
          localStorage.removeItem('token');
        } else if (error.status === 400) {
          // Handle bad request error
          this.toast({
            title: this.translate.instant('bad_request'),
            // message: error.error?.message || this.translate.instant('invalid_request_message'),
            message: 'Lỗi request #4',
            type: 'danger',
          });
        } else {
          // Handle other errors
          this.toast({
            title: this.translate.instant('error'),
            // message: error.message || this.translate.instant('unexpected_error_message'),
            message: `Lỗi request #3 ${JSON.stringify(error)}`,
            type: 'danger',
            delay: 10000
          });
        }
        return throwError(() => error);
      }),
      // Nếu login thành công
      tap((response: any) => {
        if (response && response.token) {
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('token', JSON.stringify(response.token));
          this.router.navigate(['user', 'profile']);
        }
      }),
    );

  }
  profile(): Observable<any> {
    return new Observable((observer) => {
      let profileCache = localStorage.getItem('profileCache');
      if (profileCache) {
        let profile = JSON.parse(profileCache);
        console.log('profile', profile);
        if (profile && profile.___expire <= new Date().getTime()) {
          this.getProfile(observer);
        } else if (profile && profile.___expire > new Date().getTime()) {
          console.log('profileCache', profile);
          observer.next(profile);
          observer.complete();
          return;
        }
      } else {
        this.getProfile(observer);
      }
    });
  }
  getProfile(observer: any) {
    this.callApi(`/users/profile`, {}).subscribe({
      next: (res) => {
        if (res.success) {
          res.___expire = new Date().getTime() + 60 * 60 * 1000;
          localStorage.setItem('profileCache', JSON.stringify(res));
          observer.next(res);
          observer.complete();
        } else {
          observer.error(res);
        }
      },
      error: (err) => {
        observer.error(err);
      }
    });

  }
  callApi(path: string, payload: any = null): Observable<any> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `ZSecure ${this.token}`
    };
    const request = payload ? this.http.post(`${this.env.apiUrl}${path}`, payload, { headers }) : this.http.get(`${this.env.apiUrl}${path}`, { headers });
    return request.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toast({
            title: this.translate.instant('session_expired'),
            message: this.translate.instant('session_expired_message'),
            type: 'danger',
          });
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          window.location.href = "/guest/login";
        } else if (error.status === 400) {
          // Handle bad request error
          this.toast({
            title: this.translate.instant('bad_request'),
            // message: error.error?.message || this.translate.instant('invalid_request_message'),
            message: 'Lỗi request #1',
            type: 'danger',
          });
        } else {
          // Handle other errors
          this.toast({
            title: this.translate.instant('error'),
            // message: error.message || this.translate.instant('unexpected_error_message'),
            message: `Lỗi request #2`,
            type: 'danger',
          });
        }
        return throwError(() => error);
      })
    );
  }
  get user() {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch (e) {
      return null;
    }
  }
  get token() {
    try {
      return JSON.parse(localStorage.getItem('token') || 'null');
    } catch (e) {
      return null;
    }
  }
  get isLowTech() {
    let userAgent: any = window.navigator.userAgent;
    if (userAgent != null && userAgent != undefined) {
      let iOSVersion = userAgent.match(/iPhone OS (.*) like Mac OS X/)?.pop().split(/\D/).map((a: any) => parseInt(a)).shift();
      if (iOSVersion && iOSVersion < 16) {
        return true;
      }
    }
    return false;
  }
  changeUserInterface(userInterface: string) {
    this.callApi('/users/update', { userInterface }).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.router.navigate([`/user/${userInterface}`]);
          let user = this.user;
          user.userInterface = userInterface;
          localStorage.setItem('user', JSON.stringify(user));
        }
      }, error: (err: any) => {
        console.error(err);
      }
    });
  }
  modalControl(selector: string, action: boolean = true) {
    let elementExist = document.querySelector(selector);
    if (!elementExist) {
      return;
    }
    this.modals[selector] = this.modals[selector] ?? new (window as any).bootstrap.Modal(selector);
    if (action) {
      this.modals[selector].show();
    } else {
      this.modals[selector].hide();
    }
  }
  getComponentName(componentName: string): any {
    componentName = componentName.replace(/^_/, '');
    componentName = componentName.replace(/Component$/, '');
    let apiPath = componentName
      .replace(/([a-z])([A-Z])/g, '$1_$2') // camelCase to snake_case
      .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2') // ABB -> A_BB
      .toLowerCase();
    if (apiPath.includes('_manager')) {
      apiPath = apiPath.replace(/_manager/g, '');
    }
    let clientPath = apiPath.replace(/_/g, '/').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    apiPath = '/' + apiPath;
    return { apiPath, clientPath };
  }
  back() {
    this.location.back();
  }
  logout() {
    this.callApi(`/auth/logout`).subscribe({
      next: (res) => {
        if (res.success) {
          this.toast({
            title: this.translate.instant('toast_logout'),
            message: this.translate.instant('toast_logout_message'),
            type: 'info',
          });
        }
      },
      complete: () => {
        // this.router.navigate(['/guest/login']);
        localStorage.clear();
        console.log('logout');
        setTimeout(() => {
          window.location.href = "/guest/login";
        }, 1500);
      }
    });
  }
  validateForm(form: FormGroup): void {
    console.log('validateForm', form.value);
    if (form.invalid) {
      // Nếu form không hợp lệ, thực hiện các hành động cần thiết như hiển thị thông báo lỗi
      this.toast({
        title: this.translate.instant('error'),
        message: this.translate.instant('form_invalid'),
        type: 'danger',
      });
      throw new Error('Form is invalid');
    }
  }
  async generatorQRCode(text: string) {
    try {
      // 1. Tạo QR code dưới dạng Data URL
      const qrDataUrl = await QRCode.toDataURL(text, { errorCorrectionLevel: 'H', width: 500, margin: 2 });

      // 2. Tạo canvas để vẽ QR + Logo
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;
      const img = new Image();

      // 3. Load QR code
      let result = await new Promise((resolve, reject) => {
        img.onload = async () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          // 4. Load và chèn logo
          const logo = await this.loadImage('assets/logo.png');
          const logoSize = img.width * 0.15; // 15% kích thước QR

          // Resize logo
          const resizedLogo = await this.resizeImage(logo, logoSize, logoSize);
          // thêm background trắng cho logo
          ctx.fillStyle = 'white';
          ctx.fillRect((img.width - logoSize) / 2 - 5, (img.height - logoSize) / 2 - 5, logoSize + 10, logoSize + 10);

          // Vẽ logo vào giữa
          ctx.drawImage(
            resizedLogo,
            (img.width - logoSize) / 2,
            (img.height - logoSize) / 2,
            logoSize,
            logoSize
          );

          // 5. Tạo URL để hiển thị và tải xuống
          const finalDataUrl = canvas.toDataURL('image/png');
          let qrImage = this.sanitizer.bypassSecurityTrustUrl(finalDataUrl);
          let downloadUrl = this.sanitizer.bypassSecurityTrustUrl(finalDataUrl);
          resolve({
            qrImage,
            downloadUrl,
            text,
          });
        };

        img.src = qrDataUrl;
      });
      return result;
    } catch (err) {
      console.error('Lỗi:', err);
      return null;
    }
  }
  loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Xử lý CORS nếu cần
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }
  resizeImage(
    img: HTMLImageElement,
    width: number,
    height: number
  ): Promise<HTMLCanvasElement> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);
    return Promise.resolve(canvas);
  }
  async loadModels() {
    try {
      await tf.ready();
      await faceapi.nets.tinyFaceDetector.loadFromUri('/assets/models');
      await faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models');
      await faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models');
      await faceapi.nets.ssdMobilenetv1.loadFromUri('/assets/models');
      this.shareObject.modelLoaded = true;
      console.log('face-api models loaded');
    } catch (error) {
      console.log(`face-api`, error);
    }
  }
  async checkModelLoaded(): Promise<boolean> {
    if (this.shareObject.modelLoaded && this.shareObject.modelLoaded === true) {
      return true;
    }
    await new Promise((s) => setTimeout(() => { s(true); }, 100));
    return this.checkModelLoaded();
  }
  async idScan(face: any = null) {
    await this.checkModelLoaded();
    return new Promise(async (resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';

      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');

      el.appendChild(videoEl);
      document.body.appendChild(el);

      let img = document.createElement('img');
      img.src = 'assets/faceid.svg';
      img.style.cssText = 'position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);pointer-events: none;z-index: 9999;height: calc(100vh - 100px);';
      el.appendChild(img);

      let cameraType: 'user' | 'environment' = 'user';
      let cameraStream: MediaStream | null = null;
      let intervalId: any = null;
      let isScanning = true;

      const openCamera = async () => {
        try {
          if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
          }
          cameraStream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: { ideal: 1920 },
              height: { ideal: 1080 },
              facingMode: cameraType
            }
          });
          videoEl.srcObject = cameraStream;
        } catch (error: any) {
          console.error('Error accessing camera:', error);
          if (error.name === 'AbortError') {
            this.toast({
              title: this.translate.instant('camera_error'),
              message: this.translate.instant('Thao tác đã bị hủy. Hãy kiểm tra quyền truy cập camera.'),
              type: 'danger'
            });
          } else if (error.name === 'NotAllowedError') {
            this.toast({
              title: this.translate.instant('camera_error'),
              message: this.translate.instant('Bạn đã từ chối cấp quyền camera.'),
              type: 'danger'
            });
          }
          reject(error);
        }
      };

      await openCamera();

      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        isScanning = false;
        if (intervalId) clearInterval(intervalId);
        if (cameraStream) {
          cameraStream.getTracks().forEach(track => track.stop());
        }
        videoEl.srcObject = null;
        el.remove();
        resolve(null);
      };
      el.appendChild(btnClose);

      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      btnSwitchCamera.onclick = async () => {
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        await openCamera();
      };
      el.appendChild(btnSwitchCamera);

      intervalId = setInterval(async () => {
        if (!isScanning || !videoEl.srcObject) return;

        try {
          const faceScan = await faceapi.detectSingleFace(videoEl).withFaceLandmarks().withFaceDescriptor();
          if (faceScan) {
            img.style.filter = `hue-rotate(${360 - Math.floor((faceScan.detection.score * 180) + 90)}deg)`;

            if (face && faceScan.detection.score >= 0.90) {
              let distance = faceapi.euclideanDistance(faceScan.descriptor, face);
              console.log('distance:', distance);
              if (distance < 0.35) {
                isScanning = false;
                clearInterval(intervalId);
                if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
                videoEl.srcObject = null;
                el.remove();
                resolve(true);
              }
            }

            if (!face && faceScan.detection.score >= 0.98) {
              isScanning = false;
              clearInterval(intervalId);
              if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
              videoEl.srcObject = null;
              el.remove();
              resolve(Object.values(faceScan.descriptor));
            }
          } else {
            img.style.filter = 'hue-rotate(290deg)';
          }
        } catch (err) {
          console.error('faceapi error:', err);
          // tránh lỗi crash nếu video đã bị hủy
        }

      }, 1000);
    });
  }

  async idScans(users: any = null) {
    await this.checkModelLoaded();
    users = users || [];
    if (users.length > 0) {
      users = users.map((user: any) => {
        return {
          id: user.employee.id,
          name: user.employee.profile.name,
          face: user.faceId || null
        };
      });
    }
    return new Promise(async (resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';
      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');
      el.appendChild(videoEl);
      document.body.appendChild(el);
      // videoEl.srcObject = await navigator.mediaDevices.getUserMedia({
      //   video: {
      //     width: { ideal: 1920 },
      //     height: { ideal: 1080 }
      //   }
      // });
      try {
        videoEl.srcObject = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        });
      } catch (error: any) {
        console.error('Error accessing camera:', error);
        if (error.name === 'AbortError') {
          this.toast({
            title: this.translate.instant('camera_error'),
            message: this.translate.instant('Thao tác đã bị hủy. Hãy kiểm tra quyền truy cập camera.'),
            type: 'danger'
          });
        } else if (error.name === 'NotAllowedError') {
          this.toast({
            title: this.translate.instant('camera_error'),
            message: this.translate.instant('Bạn đã từ chối cấp quyền camera.'),
            type: 'danger'
          });
        }
      }
      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        videoEl.srcObject = null;
        videoEl.src = '';
        document.body.removeChild(el);
        resolve(null);
      };
      el.appendChild(btnClose);
      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      let cameraType = 'environment';
      btnSwitchCamera.onclick = () => {
        let stream = videoEl.srcObject as MediaStream;
        if (stream) {
          stream.getTracks().forEach(track => track.stop());
        }
        videoEl.srcObject = null;
        videoEl.src = '';
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        navigator.mediaDevices.getUserMedia({ video: { facingMode: cameraType } }).then((stream) => {
          videoEl.srcObject = stream;
        });
      };
      el.appendChild(btnSwitchCamera);



      let labels = document.createElement('div');
      labels.style.cssText = 'position: fixed;top: 10px;left: 10px;z-index: 9999;pointer-events: none;';
      labels.id = 'face-id-labels';
      el.appendChild(labels);
      let countTime = 0;
      let intval = setInterval(async () => {
        countTime += 0.5;
        let faces = await faceapi.detectAllFaces(videoEl).withFaceLandmarks().withFaceDescriptors();
        if (faces) {
          for (let i = 0; i < users.length; i++) {
            let user = users[i];
            for (let j = 0; j < faces.length; j++) {
              let face = faces[j];
              console.log('face', user.name, face.detection.score);
              if (face.detection.score >= 0.95) {
                let distance = faceapi.euclideanDistance(face.descriptor, user.face);
                console.log('distance', user.name, distance);

                if (distance < 0.35) {
                  let label: any = labels.querySelector(`#face-id-label-${user.id}`);
                  console.log('countTime:', countTime);
                  // if (user.countTime && countTime - user.countTime >= 30) {
                  //   console.log(user.countTime, countTime);
                  //   label.style.cssText = 'background-color: rgba(255, 255, 255, 0.8);padding: 5px 15px;border-radius: 5px;z-index: 9999; margin-bottom: 5px;pointer-events: auto;cursor: pointer;';
                  // }
                  if (!label && (!user.countTime || (user.countTime && countTime - user.countTime >= 30))) {
                    label = document.createElement('div');
                    label.style.cssText = 'background-color: rgba(255, 255, 255, 0.8);padding: 5px 15px;border-radius: 5px;z-index: 9999; margin-bottom: 5px;pointer-events: auto;cursor: pointer;';
                    label.id = `face-id-label-${user.id}`;
                    labels.appendChild(label);
                    label.onclick = () => {
                      label.style.backgroundColor = 'rgba(32, 202, 89, 0.5)';
                      label.style.color = 'rgb(255, 255, 255)';
                      this.callApi('/employee_attendance/attendance_from_station', { userId: user.id }).subscribe({
                        next: (res: any) => {
                          if (res.success) {
                            this.toast({
                              title: this.translate.instant('attendance_success'),
                              message: `${user.name} ${this.translate.instant('attendance_success_message')}`,
                              type: 'success'
                            });
                            user.countTime = countTime;
                            label.style.pointerEvents = 'none';
                            label.style.backgroundColor = 'rgba(4, 48, 19, 0.5)';
                            label.style.color = 'rgb(255, 255, 255)';
                            //remove label after 5 seconds
                            setTimeout(() => {
                              labels.removeChild(label);
                            }, 5000);
                          } else {
                            this.toast({
                              title: this.translate.instant('attendance_failed'),
                              message: `${user.name} ${this.translate.instant('attendance_failed_message')}`,
                              type: 'danger'
                            });
                          }
                        },
                        error: (err) => {
                          this.toast({
                            title: this.translate.instant('attendance_failed'),
                            message: `${user.name} ${this.translate.instant('attendance_failed_message')}`,
                            type: 'danger'
                          });
                        }
                      });
                    }
                  }
                  // label.innerHTML = `Điểm danh ${user.name}`;
                  label.innerHTML = `${this.translate.instant('attendance_for_user')} ${user.name}`;
                }
              }
            }
          }
        } else {
          console.log('No face detected');
        }
      }, 500);
    })
  }

  async qrScan() {
    return new Promise((resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';
      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');
      el.appendChild(videoEl);
      document.body.appendChild(el);
      let qrScanner = new QrScanner(
        videoEl,
        (result: any) => {
          if (result) {
            qrScanner.stop();
            qrScanner.destroy();
            document.body.removeChild(el);
            resolve(result.data);
          }
        },
        {
          highlightScanRegion: true,
          highlightCodeOutline: true,
        }
      );
      qrScanner.start();

      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        qrScanner.stop();
        qrScanner.destroy();
        document.body.removeChild(el);
        resolve(false);
      };
      el.appendChild(btnClose);
      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      let cameraType = 'environment';
      btnSwitchCamera.onclick = () => {
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        qrScanner.setCamera(cameraType);
      };
      el.appendChild(btnSwitchCamera);

    });
  }
  translateKeyword() {
    //Day of week
    this.translate.instant('monday');
    this.translate.instant('tuesday');
    this.translate.instant('wednesday');
    this.translate.instant('thursday');
    this.translate.instant('friday');
    this.translate.instant('saturday');
    this.translate.instant('sunday');
  }
  copyText(text: string) {
    let textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    textArea.style.opacity = '0'; // Make it invisible
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy text:', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
}


